/** Plan de ahorro deshabilitado hasta que haya oferta en Hyundai. */
export const PLAN_AHORRO_ENABLED = false;
